function get_custom_checked(obj){

  var variant_name = $(obj).parent().attr("id");
  var cid = $(obj).attr("id");
  var cls = $("#"+cid).attr('class');
	
  if ( $("#"+cid).hasClass("checked") ) {
	$(obj).removeClass("checked");
  } 
  else{
	   $('.variant_name-'+variant_name).removeClass("checked");
	   $(obj).addClass("checked");	   
  }
  $('#option_input-'+variant_name).val(obj.id);
}


function alert_error(){
  var variant_class = $('#product-select').find('option:selected').attr('class');
  if(variant_class == 'option-DefaultTitle'){
    return true;
  }else{
    var select_value_array = $('.all_inputs').map(function() {    
       return this.value;
    }).get();  

    var full_value = select_value_array.join("-");
    var option_value = $('.option-'+full_value).val();
	
    if(option_value == undefined){
      alert("Please select an option. ")
      return false;
    }
    else{
      $('#product-select').val(option_value);
      return true;
    }
  } 
}


$(document).ready(function(){
  $("#mc-embedded-subscribe").click(function(){
    var suc_res = $('#mce-EMAIL').val();
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if(suc_res!=""){
      if(!suc_res.match(re)) {
//           alert("Invalid email");
      }else{ 
        $(".success_msg").css('display','block');
        setTimeout(function () {
           $(".success_msg").fadeOut();
              var suc_res = $('.success_msg').text();
             if (suc_res.indexOf('Thank') >= 0){
                $("#js-subscribe").fadeOut();
                $(".show-modle").css('overflow','visible');
              }          
         }, 3500);

      }
    }
    
  });
});